import { define } from 'wicked-elements'

/**
 * Replaces image with iframe on click
 */

define('[data-component~="video-switcher"]', {
  init () {
    this.imageElement = this.element.querySelector('img')
    this.templateElement = this.element.querySelector('template')
    this.swap = this.swap.bind(this)
  },
  connected () {
    this.imageElement.addEventListener('click', this.swap)
  },
  disconnected () {
    if (this.imageElement) {
      this.imageElement.removeEventListener('click', this.swap)
    }
  },
  swap () {
    this.imageElement.removeEventListener('click', this.swap)
    let iframe = this.templateElement.content.querySelector('iframe')
    if (iframe) {
      this.element.appendChild(iframe)
    }
    this.element.classList.add('played')
  }
})